module.exports = JSON.parse('{"Series is tracked":"Серия отслеживается","Series is untracked":"Серия не отслеживается","Viewport":"Область просмотра"}')